// 7.2.2 IsArray(argument)
var cof = require('./_cof');
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};



//////////////////
// WEBPACK FOOTER
// ./~/element-ui/~/core-js/library/modules/_is-array.js
// module id = GGiO
// module chunks = 15